import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks";

import Cookies from "js-cookie";
import values from "../../values";
import utils from "../../utils";
import { ForbiddenScreen } from "../../screen";

type Props = {
  Component: JSX.Element;
  name?: string;
};

const ProtectedRoute = ({ Component, name }: Props) => {
  const isAuthenticate = useAuth();

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(values.constants.USER.TYPE)
  );
  const currentBaseUrl = window.location.pathname.split("/")[2];

  if (!isAuthenticate) return <Navigate to={`/panel/login`} />;

  switch (userType) {
    case "ADMIN":
      if (currentBaseUrl === "administrator") return Component;
      else return <ForbiddenScreen />;
    case "SUPER_AGENT_SCHOOL":
      if (currentBaseUrl === "super-agent") return Component;
      else return <ForbiddenScreen />;
    case "COMPANY":
      if (currentBaseUrl === "company") return Component;
      else return <ForbiddenScreen />;
    case "MUNICIPALITY":
      if (currentBaseUrl === "municipality") return Component;
      else return <ForbiddenScreen />;
    case "GOVERNMENTSHIP":
      if (currentBaseUrl === "government-ship") return Component;
      else return <ForbiddenScreen />;
    case "PROVINCE_EDUCATION":
      if (currentBaseUrl === "province-education") return Component;
      else return <ForbiddenScreen />;
    default:
      utils.cookiesValue.remove();
      break;
  }
  return <></>;
};

export default ProtectedRoute;
